import { Component, Input, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FormGroup, FormControl, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-textarea';
import '@maersk-global/mds-components-core/mc-switch';
import { RepairCodeService } from '../../../services/repair-code.service';
import { CodeDescription } from '../../../models/code-description.model';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-repair-code-information',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './repair-code-information.component.html',
    styleUrls: ['./repair-code-information.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RepairCodeInformationComponent implements OnInit {
    @Input() formGroup!: FormGroup;
    @Input() isEditMode: boolean = false;

    repairModeList: CodeDescription[] = [];
    isLoadingModes = false;

    constructor(private readonly repairCodeService: RepairCodeService) {}

    ngOnInit(): void {
        this.loadModes();
    }

    private async loadModes(): Promise<void> {
        this.isLoadingModes = true;
        try {
            const modes = await firstValueFrom(this.repairCodeService.getAllRepairModes());
            this.repairModeList = modes || [];
        } catch {
            this.repairModeList = [];
        } finally {
            this.isLoadingModes = false;
        }
    }

    onModeChange(event: Event): void {
        const customEvent = event as CustomEvent;
        const selectedMode = customEvent?.detail?.value ?? customEvent?.detail;
        if (selectedMode) {
            this.formGroup.get('repairMode')?.setValue(selectedMode);
        }
    }

    onSwitchChange(event: Event, controlName: string): void {
        const customEvent = event as CustomEvent;
        const checked = customEvent?.detail?.checked ?? (event.target as HTMLInputElement)?.checked ?? false;
        this.formGroup.get(controlName)?.setValue(checked);
        this.formGroup.get(controlName)?.markAsDirty();
    }

    isControlInErrorState(control: FormControl | AbstractControl | null | undefined): boolean | null {
        if (control?.invalid && control.touched) {
            return true;
        }
        return null;
    }
}
